<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-input
          v-model="questionnaireTitle"
          label="عنوان پرسشنامه را اینجا وارد نمایید"
          filled
          clearable
          clear-icon="clear"
      >
        <template v-slot:append>
          <q-btn v-if="questionnaireTitle && questionnaireTitle!==''" flat round icon="check" color="indigo"
                 @click="addNewItem"/>
        </template>
      </q-input>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "QuestionnaireCU",
  props: {
    actions: {
      type: String
    },
    items: {
      type: []
    }
  },
  data() {
    return {
      questionnaireTitle: ''
    }
  },
  methods: {
    ...mapActions({
      questionCRUD: 'Questions/crudQuestion'
    }),
    addNewItem() {
      const founded = this.items.filter(record => record.Title === this.questionnaireTitle)
      if (founded.length === 0) {
        this.questionCRUD({
          title: this.questionnaireTitle,
          action:'insert'
        }).then((res) => {
          this.items.push(res[0])
          this.questionnaireTitle = ''
        })
      }
    }
  },
  created() {
  }
}
</script>

<style scoped>

</style>